import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitLoadersSkeleton.module.scss';

const Skeleton = ({
  count = 1,
  height = '',
  isCircle = false,
  testId = '',
  width = '',
  className = '',
}) => {
  const items = [];

  for (let i = 0; i < count; i += 1) {
    const style = {};
    let isEmpty = null;

    if (width === '' && height === '') {
      isEmpty = true;
    }

    if (width !== '') {
      style.width = width;
    }

    if (height !== '') {
      style.height = height;
    }

    items.push(
      <span
        key={i}
        className={classnames(styles.skeleton, {
          [styles.isCircle]: isCircle,
          [styles.isEmpty]: isEmpty,
        })}
        style={style}
      />,
    );
  }

  return (
    <div className={classnames(styles.element, className)} data-testid={testId}>
      {items.map((item) => item)}
    </div>
  );
};

Skeleton.propTypes = {
  count: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isCircle: PropTypes.bool,
  testId: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export { Skeleton as SkeletonStorybook };
export default React.memo(Skeleton);
